module.exports = __webpack_public_path__ + "static/media/hibiki-otsuki-lesb.ec67dd50.jpg";